import { Select } from '@iwoca/orion';
import classNames from 'classnames';
import { useIntl } from 'react-intl';

import styles from './SelectPhoneNumber.module.css';
import { TDeserialisedPerson } from '../IdCheckVerificationModal.types';

const ADD_NEW_VALUE = 'ADD_NEW';

export const SelectPhoneNumber = ({
    value,
    onChange,
    disabled,
    addNewNumber,
    options
}: {
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
    addNewNumber: () => void;
    options: TDeserialisedPerson['phones'];
}) => {
    const intl = useIntl();

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = event.target.value;
        if (selectedValue === ADD_NEW_VALUE) {
            addNewNumber();
            return;
        }
        onChange(selectedValue);
    };

    return (
        <Select
            className={classNames(styles.SelectPhoneNumber, 'fs-exclude')}
            placeholder={intl.formatMessage({
                id: '_.modal.id_check_verification.selectPlaceholder',
                defaultMessage: 'Select number'
            })}
            disabled={disabled}
            value={value || ''}
            onChange={handleChange}
        >
            {options.map((phone) =>
                phone.type === ADD_NEW_VALUE ? (
                    <option
                        key={ADD_NEW_VALUE}
                        value={ADD_NEW_VALUE}
                        data-testid="phoneNumberOption"
                    >
                        {intl.formatMessage({
                            id: '_.modal.id_check_verification.add_number',
                            defaultMessage: 'Add a number'
                        })}
                    </option>
                ) : (
                    <option
                        key={phone.uid}
                        value={phone.value ?? ''}
                        data-testid="phoneNumberOption"
                    >
                        {phone.label}
                    </option>
                )
            )}
        </Select>
    );
};
